import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class RfBJTAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVceoMin = 2;
		this.normFtMin = 5;
		this.normIc = 1;
		this.normHfeMin = 5;

		this.rankVceoMin = 0;
		this.rankFtMin = 0;
		this.rankIc = 0;
		this.rankHfeMin = 0;

		this.weightVceoMin = 0.1;
		this.weightFtMin = 0.2;
		this.weightIc = 0.1;
		this.weightHfeMin = 0.1;

		this.rVceoMin = 0;
		this.rFtMin = 0;
		this.rIc = 0;
		this.rHfeMin = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_VceoMin,rVceoMin,rankVceoMin,' +
					'part_FtMin,rFtMin,rankFtMin,' +
					'part_Ic,rIc,rankIc,' +
					'part_HfeMin,rHfeMin,rankHfeMin,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Collector-Emitter Breakdown voltage  VCEO Min (V)---------------------------------------------

		[this.rankVceoMin, this.rVceoMin] = this.calculateRankSingleSliderGTE(
			CIDS.COLLECTOR_EMITTER_VOLTAGE,
			product,
			this.normVceoMin
		);

		// ---------------------------------------------Transition frequency  fT Min (MHz)---------------------------------------------

		[this.rankFtMin, this.rFtMin] = this.calculateRankSingleSliderGTE(
			CIDS.TRANSITION_FREQUENCY,
			product,
			this.normFtMin
		);

		// ---------------------------------------------Collector current  IC Continuous (A)---------------------------------------------

		[this.rankIc, this.rIc] = this.calculateRankSingleSliderGTE(CIDS.CONTINUES_COLLECTOR_CURRENT, product, this.normIc);

		// ---------------------------------------------Forward current transfer ratio  hFE Min---------------------------------------------

		[this.rankHfeMin, this.rHfeMin] = this.calculateRankSingleSliderGTE(
			CIDS.FORWARD_CURRENT_TRANSFER_RATIO_MIN,
			product,
			this.normHfeMin
		);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightVceoMin * this.rankVceoMin +
			this.weightFtMin * this.rankFtMin +
			this.weightIc * this.rankIc +
			this.weightHfeMin * this.rankHfeMin;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightVceoMin - this.weightFtMin - this.weightIc - this.weightHfeMin) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
